import { proxy, useSnapshot } from 'valtio';
export type OverlayStatus = 'OPEN' | 'CLOSE';
interface RemoveWatchMessageState {
  type: boolean;
}
export const removeWatchMessageStateActions = {
  changeRemoveWatchMessageStateActions: (status: boolean) => {
    removeWatchMessageState.type = status;
  },
};

export const removeWatchMessageState = proxy<RemoveWatchMessageState>({
  type: false,
});

export const useRemoveWatchMessageState = () =>
  useSnapshot(removeWatchMessageState);
